import { useEffect, useState } from "react";

export const useNetworkQuality = (pcRef) => {
  const [stats, setStats] = useState({
    rtt: null,
    bitrate: null,
    packetLoss: null,
    quality: "unknown",
  });

  useEffect(() => {
    if (!pcRef.current) return;

    let lastBytesSent = 0;
    let lastTimestamp = 0;

    const interval = setInterval(async () => {
      const reports = await pcRef.current.getStats();

      reports.forEach((r) => {
        if (r.type === "outbound-rtp" && r.kind === "video") {
          if (lastTimestamp) {
            const bitrate =
              ((r.bytesSent - lastBytesSent) * 8) /
              (r.timestamp - lastTimestamp);

            setStats((s) => ({
              ...s,
              bitrate,
              packetLoss: r.packetsLost ?? 0,
            }));
          }

          lastBytesSent = r.bytesSent;
          lastTimestamp = r.timestamp;
        }

        if (r.type === "candidate-pair" && r.state === "succeeded") {
          const rtt = r.currentRoundTripTime;

          let quality = "excellent";
          if (rtt > 0.6) quality = "poor";
          else if (rtt > 0.3) quality = "good";

          setStats((s) => ({
            ...s,
            rtt,
            quality,
          }));
        }
      });
    }, 2000);

    return () => clearInterval(interval);
  }, [pcRef]);

  return stats;
};
